/**
 * Adds commas to numbers. Some places right now format numbers for display in models
 * but those models can't use things like the numbers pipe yet. This is meant to help those
 * cases without refactoring the way it all works right now.
 * @param num the number to format
 */
export function numberWithCommas(x: string | number | null) {
  if (x === null || x === undefined) {
    return null;
  } // don't want to do a truthy check because 0 would get caught

  // https://stackoverflow.com/a/2901298/13752362 modified version of this response to deal with long decimals
  // matcher: \B match the space between every character in a word
  // positive lookahead: (?=(\d{3}) match when there's a group of 3 numbers ahead
  // modifier: + modifies above so that any number of groups of 3 digits count. So 3, 6, 9 digits in a row, etc
  // negative lookahead: (?!\d) the character after the groups of 3 digits can't be a number.

  // possible improvements: don't match if there's a alphabetic character anywhere in the number "word"
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
